// removed by extract-text-webpack-plugin
module.exports = {"nearMeMobile":"IiITCRIJyZx7WjggiI7Cw","sliderNearMeWrapper":"_3y5LDmPMVOXDlWCJBSQRVC","sliderNearMe":"_2xyU0e0H9Wt4G-krX3fP5H","headerBox":"_1ww8oNCjvI1yUGCiIwUN5Z","header":"_13TRX6eqfrv-WM7oKl1Cjf","right":"mj4waer64_6nIELSriK8e","seeMore":"_16cYfBhSzFjnjGVVfNpvp-","arrowRight":"_1oAaB5JrvHa0YYNvoPc_JZ","left":"_1wHGF37zYQVpqgVgeCFyLI","title":"_3NTkx64Yrch083Bq6qM3gI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/GeneralViewMobile.scss
// module id = 1128
// module chunks = 0